import { ThemeConfig } from "antd";
import { ITheme } from "survey-core";

export const convertSurveyThemeToAntdConfig = (
  surveyThemeJson: ITheme,
): ThemeConfig => {
  const primaryColor =
    surveyThemeJson?.cssVariables?.["--sjs-primary-backcolor"] ?? "#000000";
  return {
    inherit: false,
    token: {
      colorPrimary: primaryColor,
      colorInfoBorder: primaryColor,
      colorInfoBg: "#efefef",
      borderRadius: 4,
      fontSize: 14,
      controlHeight: 40,
    },
    components: {
      Button: {
        paddingInline: 64,
      },
    },
  };
};
